export default {
	name: "MapFollowableMixin",

	inject: [ "storeModuleName" ],

	props: {
		followable: Boolean
	},

	computed: {
		autoFollow: {
			get() {
				return this.$store.state[this.storeModuleName].autoFollow;
			},
			set( follow ) {
				if ( this.active ) {
					this.$store.dispatch( `${this.storeModuleName}/setAutoFollow`, follow );
				}
			}
		},

		following() {
			return this.active && this.autoFollow;
		},

		mapZoom() {
			return this.$store.state[this.storeModuleName].mapZoom;
		}
	},

	watch: {
		autoFollow() {
			if ( this.following ) {
				this.panTo();
			}
		},

		centered() {
			if ( this.following ) {
				this.panTo();
			}
		},

		mapZoom() {
			if ( !this.panToActive ) {
				this.autoFollow = false;
			}
		}
	}
};
